import { render, staticRenderFns } from "./djgver.vue?vue&type=template&id=4995d452&scoped=true"
import script from "./djgver.vue?vue&type=script&lang=js"
export * from "./djgver.vue?vue&type=script&lang=js"
import style0 from "./djgver.vue?vue&type=style&index=0&id=4995d452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4995d452",
  null
  
)

export default component.exports